import Model from '@/models/Model.js';

export default class TimelineCheckpointType extends Model {
    static entity = 'timeline_checkpoint_types';

    static fields() {
        return {
            id: this.attr(null),
            is_graduation: this.attr(null),
            icon_id: this.attr(null),
            title: this.string(''),

            ...super.fields(),

            icon: this.belongsTo('icons', 'icon_id'),
        };
    }

    static defaultIcon() {
        return 'check-circle';
    }
}
